import React, { useEffect, useCallback } from 'react'
import { useIntl } from 'gatsby-plugin-react-intl'

import closeModal from '../../images/icons/close-modal.svg'

import * as S from './styled'

let url = ''
let title = ''

function Modal({ nameVideo, isOpen, onClickClose, closed }) {
  const intl = useIntl()

  const handleKeyDown = useCallback(
    (evt) => {
      if (evt.keyCode === 27) {
        closed()
      }
    },
    [closed]
  )

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown)
    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  })

  if (!isOpen) {
    return null
  }

  ;(() => {
    let idVideo = ''
    switch (nameVideo) {
      case 'video-02':
        idVideo = 'zrHOU5kpdEo'
        title = 'Como a Finamax derrubou sites falsos e evitou que clientes caíssem em golpes'
        break

      case 'video-03':
        idVideo = 'dhOcmnPEjfU'
        title = 'Como a Easynvest protege seus clientes contra fraudes'
        break

      case 'video-04':
        idVideo = 'wSqQVzSQaIs'
        title = 'Como a Ricardo Eletro reduziu tentativas de fraude e aumentou a confiança de seus clientes.'
        break

      case 'video-05':
        idVideo = 'Ns_kPkcsktA'
        title = 'Como a Polar conseguiu remover vendas ilegais e aumentar a receita'
        break

      case 'gptw':
        idVideo = 'YfLyJnFnq4c'
        title = 'Somos Great Place to Work! - Axur'
        break

      case 'why-axur':
        idVideo = intl.formatMessage({ id: 'why_axur.hero.video' })
        title = 'Elimine fraudes e riscos digitais na web. Automaticamente'
        break

      case 'video-01':
      default:
        idVideo = 'NJ0BK1Dcat4'
        title = 'Como a Empiricus combate as ameaças digitais com a Axur'
    }
    url = `https://www.youtube.com/embed/${idVideo}?rel=0&autoplay=1&hl=${intl.formatMessage({ id: 'og_locale' })}`
  })()

  return (
    <S.ModalOverlayWrapper onClick={onClickClose}>
      <S.BoxModal>
        <button onClick={onClickClose}>
          <img src={closeModal} alt="Clique para fechar o modal" />
        </button>
        <S.Embed>
          <iframe
            title={title}
            src={url}
            frameBorder="0"
            allow="accelerometer; fullscreen; autoplay; encrypted-media; gyroscope; picture-in-picture"
          ></iframe>
        </S.Embed>
      </S.BoxModal>
    </S.ModalOverlayWrapper>
  )
}

export default Modal
